module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "icon-512x512.ea3fdf22.png";